import gql from "graphql-tag";

export const SEND_NOTIFICATION = gql`
  mutation sendNotification($postId: String!) {
    sendNotification(postId: $postId)
  }
`;
